import close from "../assets/icons/close.png";
import { SideMenuText as text  } from '../database/SubscriptionText';
import {HeadersText as header} from "../database/Text";
import { useMainContext } from '../callContext/MainContext';
import {Link} from 'react-router-dom';
import { isFacebookCampaign } from '../utils/Helpers';
const Sidemenu = ({isOpen, setMenuOpen }) => {
    const {language}=useMainContext();
    //facebook campaign users should not see account (user details)
    const menuItems=isFacebookCampaign()?text?.filter((item)=>item?.link!=="/account"):text;
    return (
        <>
      {isOpen &&  <div
        className="fixed inset-0  bg-opacity-20 z-[998] max-w-[500px] m-auto"
      >
    <div
      className={`h-full w-64 yellow-theme-color text-white z-[999] transition-transform duration-300 ease-in-out translate-x-0 rounded-r-lg}`}
    >
        <div className='flex justify-between p-4'>
            <h1 className='text-lg font-bold'>{header?.magicVoiceText?.[language]}</h1>
        <button onClick={()=>setMenuOpen(false)} className="text-white">
            <img src={close} alt="close" className='float-right h-6'/>
        </button>
        </div>
        <ul className="text-white p-4 flex flex-col">
          {menuItems?.map((item,index)=>{
            return(
                <Link key={item?.id} to={item?.link} className='text-lg py-1'>{item?.title?.[language]}</Link>
            )
          })}
        </ul>
      </div>
      </div>
      }
      </>
    );
  }
export default Sidemenu